export default __webpack_public_path__ + "static/media/upload-reset.c1a4306e.svg";